import React from 'react';
import { IconsPropsType } from './icons.config.type';

const Outcome: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="40"
      height="35"
      viewBox="0 0 40 35"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="34" rx="4.5" stroke="black" />
      <path
        d="M9 24.9378H13C13.1667 20.6045 13.4911 14.7051 15.4911 12.2051C16.8658 10.4867 19.6832 9.02684 19.5 9.06546C25.4911 8.20508 30.9166 16.0229 32.5 20.9378L35.4911 20.9378L31 24.9378L28.5 22.9378L25 20.9378H28.4911C29.4911 20.9378 24.9911 12.7051 22.5 10.9378C20.7511 9.69702 19.8389 9.18707 19.5 9.06546C7.25 8.19312 9.49109 23.7052 9 24.9378Z"
        fill="#5b5b5b"
      />
    </svg>

    // </div>
  );
};

Outcome.defaultProps = {
  style: { width: '40px', height: '35px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default Outcome;
